import { TABLE_COLUMN_WIDTH } from "components/ModelCompare/constants";

import type { Section } from "../types";
import { aggregation } from "./products/aggregation";
import { standard16PoE } from "./products/standard16PoE";
import { standard24 } from "./products/standard24";
import { standard24PoE } from "./products/standard24PoE";
import { standard48 } from "./products/standard48";
import { standard48PoE } from "./products/standard48PoE";
import {
  dimensions,
  downlinkSpeed,
  poeAvailability,
  poeOutput,
  portCount,
  uplinkSpeed,
} from "./properties";

export const SwitchingValue: Section = {
  properties: [
    dimensions,
    portCount,
    downlinkSpeed,
    uplinkSpeed,
    poeOutput,
    poeAvailability,
  ],
  products: [
    aggregation,
    standard48PoE,
    standard24PoE,
    standard16PoE,
    standard48,
    standard24,
  ],
  columnWidth: TABLE_COLUMN_WIDTH,
};
